import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import {
  FaVolumeUp,
  FaDownload,
  FaTrashAlt,
  FaPlay,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import AdvanceDataTable from "../UI/Table/AdvanceDataTable";
import styles from "./ManageClip.module.css";

const TTSClipApproveStatus = () => {
  const audioRef = useRef(null);
  const [clipId, setClipId] = useState(null);
  const [userIdToApprove, setUserIdToApprove] = useState(null);
  const [clipData, setClipData] = useState([]);
  const [userRouteMap, setUserRouteMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedClip, setSelectedClip] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [duration, setDuration] = useState(null);

  const [clipToDelete, setClipToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [clipToApprove, setClipToApprove] = useState(null);
  const [clipToReject, setClipToReject] = useState(null);
  const [showPlayModal, setShowPlayModal] = useState(false);
  const [audioUrl, setAudioUrl] = useState("");
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);


  const loginData = JSON.parse(localStorage.getItem("admin"));
  const user_id = loginData?.user?.userId;
  const token = loginData?.token;



  const fetchUserRoutes = async () => {
    try {
      const { data } = await axios.post(`${NODE_HOST_URL_v1}/admin/clipGroup`, {
        user_id,
        token,
        method: "fetch_app_clip",
      });

      if (data.success && data.data) {
        const map = {};
        data.data.forEach((item) => {
          if (!map[item.user_id]) {
            map[item.user_id] = new Set();
          }
          map[item.user_id].add(item.route_id);
        });
        // console.log("fetch_app_clip route map source:", data.data);


        const finalMap = {};
        for (const uid in map) {
          finalMap[uid] = Array.from(map[uid]);
        }

        setUserRouteMap(finalMap);
        return finalMap;
      }
    } catch (err) {
      console.error("Error fetching route IDs:", err);
    }

    return {};
  };


  const fetchClips = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${NODE_HOST_URL_v1}/admin/clipGroup`, {
        user_id,
        token,
        method: "fetch_tts_clip",
      });

      // console.log("API Response:", data);
      // console.log("Clip status values:", data.tts_clip.map(item => item.status));

      if (data.success && data.tts_clip && data.tts_clip.length > 0) {
        const expanded = data.tts_clip
          .sort((a, b) => new Date(b.created_date) - new Date(a.created_date))
          .map((item) => ({
            clipId: item.id,
            userId: item.user_id,
            username: item.username || "-",
            clipName: item.clip_name,
            fileName: item.filename,
            filePath: item.file_path,
            routeid: item.routeid,
            audioUrl: `https://db2.authkey.io/${item.file_path}`,
            status:
              item.status === 1
                ? "Approved"
                : item.status === 0
                  ? "Pending"
                  : item.status === 2
                    ? "Rejected"
                    : "null",
            createdDate: new Date(item.created_date).toLocaleString(),
            duration: item.duration ? `${item.duration} sec` : "_",
            tts: item.tts || "",
          }));

        setClipData(expanded);
      } else {
        setClipData([]);
      }
    } catch (error) {
      setClipData([]);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    const loadData = async () => {
      await fetchClips();
    };

    loadData();
  }, []);

  const handlePlay = (row) => {
    const url = `https://db2.authkey.io/${row.filePath}`;
    setAudioUrl(url);
    setShowPlayModal(true);
  };



  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration.toFixed(2));
    }
  };

  const handleDownload = (row) => {
    const link = document.createElement("a");
    link.href = `https://db2.authkey.io/${row.filePath}`;
    link.download = row.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDelete = (row) => {
    setClipToDelete(row);
    setShowDeleteModal(true);
  };

  const confirmDeleteClip = async () => {
    if (!clipToDelete) return;

    try {
      const res = await axios.post(`${NODE_HOST_URL_v1}/admin/clipGroup`, {
        user_id,
        token,
        method: "deleteClip",
        retr_user_id: clipToDelete.userId,
        id: clipToDelete.clipId,
      });

      if (res.data?.success) {
       
        fetchClips();
      } else {
       
      }
    } catch (err) {
      
    }

    setShowDeleteModal(false);
    setClipToDelete(null);
  };

  const handleApprove = (row) => {
    setClipId(row.clipId);
    setUserIdToApprove(row.userId);
    setClipToApprove(row);
    setShowApproveModal(true);
  };

  const confirmApproveClip = async () => {
    if (!clipToApprove) return;

    try {
      const res = await axios.post(`${NODE_HOST_URL_v1}/admin/AdminVoiceApprove`, {
        user_id,
        token,
        method: "adminApprove",
        clipid: clipId,
        retr_user_id: userIdToApprove,
        // route_id: clipToApprove.routeId,
      });

      if (res.data.message === "Approved Successfully") {
        alert("Clip approved successfully");
        const updatedRouteMap = await fetchUserRoutes();
        await fetchClips(updatedRouteMap);
      } else {
        alert(res.data.message || "Approval failed");
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong.";

      alert(errorMessage);
    }

    setShowApproveModal(false);
    setClipToApprove(null);
  };



  const handleReject = (row) => {
    setClipToReject(row);
    setShowRejectModal(true);
  };

  const confirmRejectClip = async () => {
    if (!clipToReject) return;

    try {
      const res = await axios.post(`${NODE_HOST_URL_v1}/admin/AdminVoiceReject`, {
        user_id,
        token,
        method: "admin_voice_reject",
        clip_id: clipToReject.clipId,
        retr_user_id: clipToReject.userId,
        // route_id: clipToReject.routeId,
      });

      if (res.data?.success) {
        alert("Clip rejected successfully");
        const updatedRouteMap = await fetchUserRoutes();
        await fetchClips(updatedRouteMap);
      } else {
        alert(res.data?.message || "Rejection failed");
      }
    } catch (err) {
      alert("Something went wrong.");
    }

    setShowRejectModal(false);
    setClipToReject(null);
  };


  const TTS_CLIP_COLUMNS = [
    { name: "User ID", selector: (row) => row.userId, sortable: true },
    { name: "Username", selector: (row) => row.username, width: "200px", sortable: true },
    {
      name: "Clip ID",
      // selector: (row) => row.clipId, 
      cell: (row) => (
        <>
          <span data-tip data-for={`tooltip-clipid-${row.clipId}`} style={{ cursor: "pointer" }}>
            {row.clipId}
          </span>
          <ReactTooltip id={`tooltip-clipid-${row.clipId}`} place="top" effect="solid">
            {row.tts?.trim() ? row.tts : "This is an audio file"}
          </ReactTooltip>
        </>
      ),
      sortable: true,
    },

    {
      name: "Clip Name",
      //  selector: (row) => row.clipName, 
      cell: (row) => (
        <>
          <span data-tip data-for={`tooltip-clipid-${row.clipName}`} style={{ cursor: "pointer" }}>
            {row.clipName}
          </span>
          <ReactTooltip id={`tooltip-clipid-${row.clipName}`} place="top" effect="solid">
            {row.tts?.trim() ? row.tts : "This is an audio file"}
          </ReactTooltip>
        </>
      ),
      sortable: true
    },
    { name: "Route ID", selector: (row) => row.routeid, sortable: true },
   {
  name: "File Name",
  cell: (row) => (
    <>
      <span
        className={styles.fileNameCell}
        data-tip
        data-for={`tooltip-filename-${row.clipId}`}
      >
        {row.fileName}
      </span>

      <ReactTooltip
        id={`tooltip-filename-${row.clipId}`}
        place="top"
        effect="solid"
      >
        {row.fileName}
      </ReactTooltip>
    </>
  ),
  width: "250px",
  sortable: true
},

    // { name: "Route ID", selector: (row) => row.routeId, sortable: true },


    {
      name: "Status",
      cell: (row) => {
        const isApproved = row.status === "Approved";
        const isRejected = row.status === "Rejected";
        return (
          <span
            style={{
              backgroundColor: isApproved
                ? "#d4f9e1"
                : isRejected
                  ? "#ffe6e6"
                  : "#fff4cc",
              color: isApproved
                ? "#046c4e"
                : isRejected
                  ? "#b30000"
                  : "#8b3e00",
              borderRadius: "9999px",
              fontWeight: 600,
              fontSize: "12px",
              display: "inline-block",
              minWidth: "90px",
              textAlign: "center",
            }}
          >
            {row.status}
          </span>
        );
      },
      sortable: true,
    },
    // { name: "Duration", selector: (row) => row.duration, sortable: true },
    { name: "Created Date", selector: (row) => row.createdDate, width: "250px", sortable: true },
    {
      name: "Actions",
      cell: (row) => {
        const showApprove = row.status === "Pending" || row.status === "Rejected";
        const showReject = row.status === "Pending" || row.status === "Approved";
        const showDelete = row.status === "Pending" || row.status === "Rejected";

        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "6px",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <FaVolumeUp
              style={{ cursor: "pointer", color: "#17a2b8", fontSize: "13px", margin: "2px" }}
              title="Play"
              onClick={() => handlePlay(row)}
            />
            <FaDownload
              style={{ cursor: "pointer", color: "#28a745", fontSize: "13px", margin: "2px" }}
              title="Download"
              onClick={() => handleDownload(row)}
            />
            {showDelete && (
              <FaTrashAlt
                style={{ cursor: "pointer", color: "#dc3545", fontSize: "13px", margin: "2px" }}
                title="Delete"
                onClick={() => handleDelete(row)}
              />
            )}

            {row.status !== "Pending" && (
              <Link to={`/admin/manage-clip/${row.clipId}`}>
                <button
                  style={{
                    backgroundColor: "#cce5ff",
                    color: "#004085",
                    padding: "2px 4px",
                    margin: "2px",
                    borderRadius: "12px",
                    fontWeight: 500,
                    fontSize: "12px",
                    border: "none",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  Check Status
                </button>
              </Link>
            )}

            {showApprove && (
              <button
                onClick={() => handleApprove(row)}
                style={{
                  backgroundColor: "#e9fce9",
                  color: "#0b6e35",
                  padding: "2px 4px",
                  borderRadius: "12px",
                  margin: "2px",
                  fontWeight: 500,
                  fontSize: "12px",
                  border: "none",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Approve
              </button>
            )}

            {showReject && (
              <button
                onClick={() => handleReject(row)}
                style={{
                  backgroundColor: "#ffe6e6",
                  color: "#b30000",
                  padding: "2px 4px",
                  margin: "2px",
                  borderRadius: "12px",
                  fontWeight: 500,
                  fontSize: "12px",
                  border: "none",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Reject
              </button>
            )}
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "250px",
    }

  ];

  return (
    <div className="wrapper">
      <AdminLeftMenu />
      <div className="main">
        <AdminHeader />
        <main className="content">
          <div className={styles.manageClipHeading}>TTS Clip Approve Status</div>

          <AdvanceDataTable
            tableCell={TTS_CLIP_COLUMNS}
            tableData={clipData}
            isLoading={loading}
            pagination={true}
          />

          {/* Delete Modal */}
          {showDeleteModal && clipToDelete && (
            <div className={styles.modalOverlay}>
              <div className={styles.deleteModal}>
                <h3 className={styles.modalTitle}>Delete clip</h3>

                <p className={styles.modalText}>
                  Are you sure you want to delete{" "}
                  <strong>{clipToDelete.clipName}</strong>?<br />
                  This clip will be permanently deleted.
                </p>

                <div className={styles.modalActions}>
                  <button
                    className={styles.cancelBtn}
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className={styles.confirmDeleteBtn}
                    onClick={confirmDeleteClip}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}


          {/* Approve Modal */}
          {showApproveModal && clipToApprove && (
            <div className={styles.modalOverlay}>
              <div className={styles.deleteModal}>
                <h3 className={styles.modalTitle}>Approve clip</h3>

                <p className={styles.modalText}>
                  <strong>{clipToApprove.clipName}</strong>{" "}
                  will be approved.
                </p>

                <div className={styles.modalActions}>
                  <button
                    className={styles.cancelBtn}
                    onClick={() => setShowApproveModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className={styles.confirmDeleteBtn}
                    onClick={confirmApproveClip}
                  >
                    Approve
                  </button>
                </div>
              </div>
            </div>
          )}


          {/* Reject Modal */}
          {showRejectModal && clipToReject && (
            <div className={styles.modalOverlay}>
              <div className={styles.deleteModal}>
                <h3 className={styles.modalTitle}>Reject clip</h3>

                <p className={styles.modalText}>
                  <strong>{clipToReject.clipName}</strong>{" "}
                  will be rejected.
                </p>

                <div className={styles.modalActions}>
                  <button
                    className={styles.cancelBtn}
                    onClick={() => setShowRejectModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className={styles.confirmDeleteBtn}
                    onClick={confirmRejectClip}
                  >
                    Reject
                  </button>
                </div>
              </div>
            </div>
          )}

          {showPlayModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  width: "400px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                }}
              >
                <h5>Play Audio</h5>
                <audio
                  controls
                  autoPlay
                  src={audioUrl}
                  style={{ width: "100%" }}
                />
                <div className="text-end mt-3">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowPlayModal(false);
                      setAudioUrl("");
                    }}
                  >
                    Close
                  </button>


                </div>
              </div>
            </div>
          )}
        </main>
        <AdminFooter />
      </div>
    </div>
  );
};

export default TTSClipApproveStatus;
